import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonLink, LargeItemCards, M2A, NowPlaying } from 'www-cms';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { ImageWithLoaderComponent } from '../components/image-with-loader/image-with-loader.component';
import { ButtonLinkComponent } from 'building-blocks/button-link/button-link.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs';
import { LargeItemCardsComponent } from '../large-item-cards/large-item-cards.component';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-now-playing',
  imports: [
    CommonModule,
    ImageWithLoaderComponent,
    ButtonLinkComponent,
    LargeItemCardsComponent,
    DirectusDirective,
  ],
  templateUrl: './now-playing.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NowPlayingComponent extends BaseBuildingBlockComponent {
  _nowPlayingData!: NowPlaying;
  // @Input({ required: true }) nowPlayingData!: NowPlaying;

  @Input({ required: true }) set nowPlayingData(value: NowPlaying) {
    this._nowPlayingData = value;
  }
  get nowPlayingData(): NowPlaying {
    return this._nowPlayingData;
  }

  get nowPayingAsLargeItemCards(): LargeItemCards {
    return {
      id: this.nowPlayingData.id,
      darkBackground: true,
      topPadding: true,
      bottomPadding: false,
      cards: [
        {
          title: this.nowPlayingData.title,
          subtitle: this.nowPlayingData.subtitle,
          image: this.nowPlayingData.image,
          buttons: this.nowPlayingData.buttons,
          hideGoldBar: true,
          allCapsSubtitle: true,
        },
      ],
    };
  }

  isSmallScreen$ = inject(BreakpointObserver)
    .observe(['(max-width: 768px)'])
    .pipe(map((res) => res.breakpoints['(max-width: 768px)']));

  trackButtons(_: number, item: M2A<ButtonLink>) {
    return item.id;
  }

  override getBgClass(): LastItemBgClass {
    return 'bg-ss-www-background';
  }
}
